import gql from 'graphql-tag'

export const GET_MODEL = gql`
  query VehicleModels {
    vehicleModels {
      isSuccessful
      message
      vehicleModels {
        model
      }
    }
  }`
